/*kiwi/build/index*/
function _(require, module, exports) {
    /*-----------------------------------------------------------------------------
| Copyright (c) 2014, Nucleic Development Team.
|
| Distributed under the terms of the Modified BSD License.
|
| The full license is in the file COPYING.txt, distributed with this software.
|----------------------------------------------------------------------------*/
    function __export(m) {
        for (var p in m)
            if (!exports.hasOwnProperty(p))
                exports[p] = m[p];
    }
    __export(require(349    /* ./variable */));
    __export(require(338    /* ./expression */));
    __export(require(337    /* ./constraint */));
    __export(require(342    /* ./strength */));
    __export(require(341    /* ./solver */));
}